import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/sign/:token',
      name: 'signing',
      component: () => import('@/views/SigningView.vue'),
      props: true,
    },
    {
      path: '/sign/:token/kiosk',
      name: 'kiosk',
      component: () => import('@/views/KioskView.vue'),
      props: true,
    },
    {
      path: '/complete/:token',
      name: 'complete',
      component: () => import('@/views/CompleteView.vue'),
      props: true,
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('@/views/ErrorView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/error',
    },
  ],
})

export default router
